import { useGetRTSolutionCardData } from '@/src/hooks/srp/RTSolutionView/getRTSolutionCardData'
import { FlightCard } from '@/src/types/flight'
import { getAirlineIcons } from '@/src/utils/confirmation/airlineUtils'
import { Circle } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

const SelectedOnwardFlightInfo = ({ flightData }: { flightData: FlightCard }) => {
    const { airlineName, airlineCodes, departureTime, arrivalTime } = useGetRTSolutionCardData(flightData)
    return (
        <Box display={'flex'} gap={0.5} alignItems={'center'}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                }}
            >
                <Box display={'flex'} maxWidth={50} overflow={'auto'} gap={0.5}>
                    {getAirlineIcons(airlineCodes, 16, 16)}
                </Box>
                <Typography
                    sx={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: "#4B5563",
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {airlineName}
                </Typography>

            </Box>
            <Circle sx={{ fontSize: 3, color: "#4B5563" }} />
            <Box display={'flex'} alignItems={'center'} gap={0.5}>
                <Typography fontSize={14} fontWeight={600}>{departureTime}</Typography>
                {'-'}
                <Typography fontSize={14} fontWeight={600}>{arrivalTime}</Typography>
            </Box>
        </Box>
    )
}

export default SelectedOnwardFlightInfo
